module.exports = __webpack_public_path__ + "static/media/kredyt_23.354de088.png";